import { Empty, Table } from 'antd'
import type { TFunction } from 'i18next'

import type { FulfillmentOrderSummaryRoot } from '@repo/sdk'

import { createOrderListColumns, type FoStatusConfigMap } from './OrderListColumns'
import { createRowClickHandler } from '@/utils/createRowClickHandler'

interface FoTableProps {
  fulfillmentOrders: readonly FulfillmentOrderSummaryRoot[]
  onViewDetail: (id: string) => void
  t: TFunction
  statusConfig: FoStatusConfigMap
}

export function FoTable({ fulfillmentOrders, onViewDetail, t, statusConfig }: FoTableProps) {
  const columns = createOrderListColumns({ onViewDetail, t, statusConfig })

  return (
    <Table
      dataSource={[...fulfillmentOrders]}
      columns={columns}
      rowKey="fulfillmentOrderId"
      pagination={false}
      size="small"
      locale={{
        emptyText: (
          <Empty description={t('pages.orders.emptyState')} image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ),
      }}
      onRow={(record) => ({
        'data-testid': `order-list-row-${record.fulfillmentOrderId}`,
        onClick: createRowClickHandler(() => onViewDetail(record.fulfillmentOrderId)),
        style: { cursor: 'pointer' },
      })}
    />
  )
}
